export default "__VITE_ASSET__18RxcXGd__"